import React from 'react';

const ChevronRightIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    id="noNavigate"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M10.4031 8.91615L6.19523 12.8099C5.92153 13.0634 5.47898 13.0634 5.20528 12.8099C4.93157 12.5567 4.93157 12.1471 5.20528 11.8939L9.41315 7.99994L5.20528 4.10614C4.93157 3.85274 4.93157 3.44333 5.20528 3.19005C5.47898 2.93665 5.92153 2.93665 6.19523 3.19005L10.4031 7.08385C10.4031 7.08385 11 7.59251 11 7.99994C11 8.40737 10.4031 8.91615 10.4031 8.91615Z"
      fill="currentColor"
    />
  </svg>
);

export default ChevronRightIcon;
